import Rest from "@/services/api_config/RestApi";

export default {
  getSettlementTrans(params) {
    var data = ``;
    if (params.id !== null && params.id !== undefined && params.id !== "") {
      data += `&id=${params.id}`;
    }
    if (params.mdr !== null && params.mdr !== undefined && params.mdr !== "") {
      data += `&mdr=${params.mdr}`;
    }
    return Rest().get("ticketko/sub/settlement-trans?" + data.substring(1));
  },
  getDashboard(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("/ticketko/dashboard?" + data.substring(1));
  },
  getPages(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("ticketko/sub/page?" + data.substring(1));
  },
  getPage(id) {
    return Rest().get("ticketko/sub/page/" + id);
  },
  addPage(data) {
    return Rest().put("ticketko/sub/add-page", data);
  },
  editPage(id, data) {
    return Rest().patch("ticketko/sub/page/" + id, data);
  },
  deletePage(id) {
    return Rest().delete("ticketko/sub/page/" + id);
  },
  getModules(params) {
    var data = ``;
    if (
      params.page_id !== null &&
      params.page_id !== undefined &&
      params.page_id !== ""
    ) {
      data += `&page_id=${params.page_id}`;
    }
    return Rest().get("ticketko/sub/module?" + data.substring(1));
  },
  getModule(id) {
    return Rest().get("ticketko/sub/module/" + id);
  },
  editModule(id, data) {
    return Rest().patch("ticketko/sub/module/" + id, data);
  },
  addModule(data) {
    return Rest().put("ticketko/sub/add-module", data);
  },
  deleteModule(id) {
    return Rest().delete("ticketko/sub/module/" + id);
  },
  getRoles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/role?" + data.substring(1));
  },
  getRole(id) {
    return Rest().get("ticketko/sub/role/" + id);
  },
  editRole(id, data) {
    return Rest().patch("ticketko/sub/role/" + id, data);
  },
  deleteRole(id) {
    return Rest().delete("ticketko/sub/role/" + id);
  },
  addRole(data) {
    return Rest().put("ticketko/sub/add-role", data);
  },
  getEmployees(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.position !== null &&
      params.position !== undefined &&
      params.position !== ""
    ) {
      data += `&position=${params.position}`;
    }
    if (
      params.web_access !== null &&
      params.web_access !== undefined &&
      params.web_access !== ""
    ) {
      data += `&web_access=${params.web_access}`;
    }
    if (
      params.role_id !== null &&
      params.role_id !== undefined &&
      params.role_id !== ""
    ) {
      data += `&role_id=${params.role_id}`;
    }
    if (
      params.card_access !== null &&
      params.card_access !== undefined &&
      params.card_access !== ""
    ) {
      data += `&card_access=${params.card_access}`;
    }
    return Rest().get("ticketko/sub/employee?" + data.substring(1));
  },
  getEmployee(id) {
    return Rest().get("ticketko/sub/employee/" + id);
  },
  editEmployee(id, data) {
    return Rest().patch("ticketko/sub/employee/" + id, data);
  },
  deleteEmployee(id) {
    return Rest().delete("ticketko/sub/employee/" + id);
  },
  getUnassignedEmployees(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/unassigned-employee?" + data.substring(1));
  },
  assignEmployees(params) {
    return Rest().post("ticketko/sub/assign-employee/", params);
  },
  getTerminals(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/terminal?" + data.substring(1));
  },
  getTerminal(id) {
    return Rest().get("ticketko/sub/terminal/" + id);
  },
  deleteTerminal(id) {
    return Rest().delete("ticketko/sub/terminal/" + id);
  },
  getUnassignedTerminals(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/unassigned-terminal?" + data.substring(1));
  },
  assignTerminals(params) {
    return Rest().post("ticketko/sub/assign-terminal/", params);
  },
  getBounds(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/bound?" + data.substring(1));
  },
  getBound(id) {
    return Rest().get("ticketko/sub/bound/" + id);
  },
  deleteBound(id) {
    return Rest().delete("ticketko/sub/bound/" + id);
  },
  getUnassignedBounds(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/unassigned-bound?" + data.substring(1));
  },
  assignBounds(params) {
    return Rest().post("ticketko/sub/assign-bound/", params);
  },
  getVehicleLayouts(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/vehicle-layout?" + data.substring(1));
  },
  getVehicleLayout(id) {
    return Rest().get("ticketko/sub/vehicle-layout/" + id);
  },
  getVehicleType(id) {
    return Rest().get("ticketko/com/vehicle-type/" + id);
  },
  deleteVehicleLayout(id) {
    return Rest().delete("ticketko/sub/vehicle-layout/" + id);
  },
  getUnassignedVehicleLayouts(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get(
      "ticketko/sub/unassigned-vehicle-layout?" + data.substring(1)
    );
  },
  assignVehicleLayouts(params) {
    return Rest().post("ticketko/sub/assign-vehicle-layout/", params);
  },
  getVehicles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/vehicle?" + data.substring(1));
  },
  getVehicle(id) {
    return Rest().get("ticketko/sub/vehicle/" + id);
  },
  deleteVehicle(id) {
    return Rest().delete("ticketko/sub/vehicle/" + id);
  },
  getUnassignedVehicles(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/unassigned-vehicle?" + data.substring(1));
  },
  assignVehicles(params) {
    return Rest().post("ticketko/sub/assign-vehicle/", params);
  },
  getUser(id) {
    return Rest().get("jti/user/" + id);
  },
  getAccessCard(id) {
    return Rest().get("jti/access-card/" + id);
  },
  getDevices(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/device?" + data.substring(1));
  },
  getDevice(id) {
    return Rest().get("ticketko/sub/device/" + id);
  },
  addDevice(data) {
    return Rest().put("ticketko/sub/add-device", data);
  },
  editDevice(id, data) {
    return Rest().patch("ticketko/sub/device/" + id, data);
  },
  deleteDevice(id) {
    return Rest().delete("ticketko/sub/device/" + id);
  },
  getUnassignedDevices(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/unassigned-device?" + data.substring(1));
  },
  assignDevices(data) {
    return Rest().post("ticketko/sub/assign-device/", data);
  },
  getDeviceUnassignedVehicles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get(
      "ticketko/sub/device-unassigned-vehicle?" + data.substring(1)
    );
  },
  getRoutes(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/route?" + data.substring(1));
  },
  getRoute(id) {
    return Rest().get("ticketko/sub/route/" + id);
  },
  addRoute(data) {
    return Rest().put("ticketko/sub/route", data);
  },
  editRoute(id, data) {
    return Rest().patch("ticketko/sub/route/" + id, data);
  },
  deleteRoute(id) {
    return Rest().delete("ticketko/sub/route/" + id);
  },
  getPassengerTypes(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/passenger-type?" + data.substring(1));
  },
  getPassengerType(id) {
    return Rest().get("ticketko/sub/passenger-type/" + id);
  },
  editPassengerType(id, data) {
    return Rest().patch("ticketko/sub/passenger-type/" + id, data);
  },
  deletePassengerType(id) {
    return Rest().delete("ticketko/sub/passenger-type/" + id);
  },
  getUnassignedPassengerTypes(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get(
      "ticketko/sub/unassigned-passenger-type?" + data.substring(1)
    );
  },
  assignPassengerTypes(params) {
    return Rest().post("ticketko/sub/assign-passenger-type/", params);
  },
  getFareMatrixs(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/fare-matrix?" + data.substring(1));
  },
  getFareMatrix(id) {
    return Rest().get("ticketko/sub/fare-matrix/" + id);
  },
  addFareMatrix(data) {
    return Rest().put("ticketko/sub/fare-matrix", data);
  },
  editFareMatrix(id, data) {
    return Rest().patch("ticketko/sub/fare-matrix/" + id, data);
  },
  plotFareMatrix(data) {
    return Rest().patch("ticketko/sub/fare-matrix-plot", data);
  },
  deleteFareMatrix(id) {
    return Rest().delete("ticketko/sub/fare-matrix/" + id);
  },
  getFuelStations(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/fuel-station?" + data.substring(1));
  },
  getFuelStation(id) {
    return Rest().get("ticketko/sub/fuel-station/" + id);
  },
  deleteFuelStation(id) {
    return Rest().delete("ticketko/sub/fuel-station/" + id);
  },
  getUnassignedFuelStations(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get(
      "ticketko/sub/unassigned-fuel-station?" + data.substring(1)
    );
  },
  assignFuelStations(params) {
    return Rest().post("ticketko/sub/assign-fuel-station/", params);
  },
  getViolations(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/violation?" + data.substring(1));
  },
  getViolation(id) {
    return Rest().get("ticketko/sub/violation/" + id);
  },
  deleteViolation(id) {
    return Rest().delete("ticketko/sub/violation/" + id);
  },
  getUnassignedViolations(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/unassigned-violation?" + data.substring(1));
  },
  assignViolations(params) {
    return Rest().post("ticketko/sub/assign-violation/", params);
  },
  getExpenses(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/expense?" + data.substring(1));
  },
  getExpense(id) {
    return Rest().get("ticketko/sub/expense/" + id);
  },
  deleteExpense(id) {
    return Rest().delete("ticketko/sub/expense/" + id);
  },
  getUnassignedExpenses(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/unassigned-expense?" + data.substring(1));
  },
  assignExpenses(params) {
    return Rest().post("ticketko/sub/assign-expense/", params);
  },
  getPaymentTypes(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/payment-type?" + data.substring(1));
  },
  getPaymentType(id) {
    return Rest().get("ticketko/sub/payment-type/" + id);
  },
  deletePaymentType(id) {
    return Rest().delete("ticketko/sub/payment-type/" + id);
  },
  getUnassignedPaymentTypes(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get(
      "ticketko/sub/unassigned-payment-type?" + data.substring(1)
    );
  },
  assignPaymentTypes(params) {
    return Rest().post("ticketko/sub/assign-payment-type/", params);
  },
  getManualTypes(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/manual-type?" + data.substring(1));
  },
  getManualType(id) {
    return Rest().get("ticketko/sub/manual-type/" + id);
  },
  deleteManualType(id) {
    return Rest().delete("ticketko/sub/manual-type/" + id);
  },
  getUnassignedManualTypes(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get(
      "ticketko/sub/unassigned-manual-type?" + data.substring(1)
    );
  },
  assignManualTypes(params) {
    return Rest().post("ticketko/sub/assign-manual-type/", params);
  },
  getSettlements(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.status !== null &&
      params.status !== undefined &&
      params.status !== ""
    ) {
      data += `&status=${params.status}`;
    }
    if (
      params.teller_status !== null &&
      params.teller_status !== undefined &&
      params.teller_status !== ""
    ) {
      data += `&teller_status=${params.teller_status}`;
    }
    return Rest().get("ticketko/sub/settlement?" + data.substring(1));
  },
  getSettlement(id) {
    return Rest().get("ticketko/sub/settlement/" + id);
  },
  approveSettlement(id, data) {
    return Rest().patch("ticketko/sub/approve-settlement/" + id, data);
  },
  getEndOfDay(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/report/end-of-day?" + data.substring(1));
  },
  getTellerSettlements(body) {
    return Rest().post("ticketko/sub/teller-settlements", body);
  },
  getPreSellDailyTransaction(params) {
    var data = ``;
    if (
      params.date !== null &&
      params.date !== undefined &&
      params.date !== ""
    ) {
      data += `&date=${params.date}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.route !== null &&
      params.route !== undefined &&
      params.route !== ""
    ) {
      data += `&route=${params.route}`;
    }
    return Rest().get(
      "ticketko/report/presell-daily-transaction?" + data.substring(1)
    );
  },
  getEndOfDayTripSummary(id) {
    return Rest().get("ticketko/report/end-of-day/trip-summary/" + id);
  },
  getEndOfDayTripSummaryHeader(params) {
    var data = ``;
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get(
      "ticketko/report/end-of-day/trip-summary-header?" + data.substring(1)
    );
  },
  getEndOfDayTripSummaryTripRecord(params) {
    var data = ``;
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    return Rest().get(
      "ticketko/report/end-of-day/trip-summary-trip-record?" + data.substring(1)
    );
  },
  getEndOfDayTripSummaryTicketIssuance(params) {
    var data = ``;
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.gross_collection !== null &&
      params.gross_collection !== undefined &&
      params.gross_collection !== ""
    ) {
      data += `&gross_collection=${params.gross_collection}`;
    }
    if (
      params.gross_revenue !== null &&
      params.gross_revenue !== undefined &&
      params.gross_revenue !== ""
    ) {
      data += `&gross_revenue=${params.gross_revenue}`;
    }
    return Rest().get(
      "ticketko/report/end-of-day/trip-summary-ticket-issuance?" +
        data.substring(1)
    );
  },
  getEndOfDayTripSummaryInpections(params) {
    var data = ``;
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    return Rest().get(
      "ticketko/report/end-of-day/trip-summary-inspections?" + data.substring(1)
    );
  },
  getEndOfDayTripSummaryCashDeposit(params) {
    var data = ``;
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    return Rest().get(
      "ticketko/report/end-of-day/trip-summary-cash-deposit?" +
        data.substring(1)
    );
  },
  getEndOfDayTripSummaryCashAdvance(params) {
    var data = ``;
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    return Rest().get(
      "ticketko/report/end-of-day/trip-summary-cash-advance?" +
        data.substring(1)
    );
  },
  getEndOfDayTripSummaryFuel(params) {
    var data = ``;
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    return Rest().get(
      "ticketko/report/end-of-day/trip-summary-fuel?" + data.substring(1)
    );
  },
  getEndOfDayTripSummaryExpenses(params) {
    var data = ``;
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    return Rest().get(
      "ticketko/report/end-of-day/trip-summary-expenses?" + data.substring(1)
    );
  },
  getEndOfDayTripSummarySpecialContents(params) {
    var data = ``;
    if (
      params.company_code !== null &&
      params.company_code !== undefined &&
      params.company_code !== ""
    ) {
      data += `&company_code=${params.company_code}`;
    }
    if (
      params.coding_param !== null &&
      params.coding_param !== undefined &&
      params.coding_param !== ""
    ) {
      data += `&coding_param=${params.coding_param}`;
    }
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    if (
      params.gross_collection !== null &&
      params.gross_collection !== undefined &&
      params.gross_collection !== ""
    ) {
      data += `&gross_collection=${params.gross_collection}`;
    }
    if (
      params.total_expense !== null &&
      params.total_expense !== undefined &&
      params.total_expense !== ""
    ) {
      data += `&total_expense=${params.total_expense}`;
    }
    if (
      params.total_partial !== null &&
      params.total_partial !== undefined &&
      params.total_partial !== ""
    ) {
      data += `&total_partial=${params.total_partial}`;
    }
    if (
      params.presell_sales !== null &&
      params.presell_sales !== undefined &&
      params.presell_sales !== ""
    ) {
      data += `&presell_sales=${params.presell_sales}`;
    }
    if (
      params.card_sales !== null &&
      params.card_sales !== undefined &&
      params.card_sales !== ""
    ) {
      data += `&card_sales=${params.card_sales}`;
    }
    if (
      params.total_cash_advance !== null &&
      params.total_cash_advance !== undefined &&
      params.total_cash_advance !== ""
    ) {
      data += `&total_cash_advance=${params.total_cash_advance}`;
    }
    if (
      params.cash_received !== null &&
      params.cash_received !== undefined &&
      params.cash_received !== ""
    ) {
      data += `&cash_received=${params.cash_received}`;
    }

    return Rest().get(
      "ticketko/report/end-of-day/trip-summary-special-contents?" +
        data.substring(1)
    );
  },
  closeEndOfDay(id) {
    return Rest().patch("ticketko/report//end-of-day/close/" + id);
  },
  getEndOfDayTickets(params) {
    var data = ``;
    if (
      params.dispatch_sync_id !== null &&
      params.dispatch_sync_id !== undefined &&
      params.dispatch_sync_id !== ""
    ) {
      data += `&dispatch_sync_id=${params.dispatch_sync_id}`;
    }
    return Rest().get("ticketko/report/end-of-day/ticket?" + data.substring(1));
  },
  getEndOfDayBaggages(id) {
    return Rest().get("ticketko/report/end-of-day/baggage/" + id);
  },
  getEndOfDayAbstract(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }

    return Rest().get(
      "ticketko/report/end-of-day/abstract?" + data.substring(1)
    );
  },
  generateAbstract(data) {
    return Rest().post("ticketko/report/end-of-day/generate-abstract", data);
  },
  getRemittanceReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/report/remittance?" + data.substring(1));
  },
  getPassengerPerRoute(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.payment_type_id !== null &&
      params.payment_type_id !== undefined &&
      params.payment_type_id !== ""
    ) {
      data += `&payment_type_id=${params.payment_type_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/report/passenger-per-route?" + data.substring(1)
    );
  },
  getPassengerStatistics(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/report/passenger-statistics?" + data.substring(1)
    );
  },
  getExpensesReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/report/expenses?" + data.substring(1));
  },
  getInspectionReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/report/inspections?" + data.substring(1));
  },
  getInspectionReportTickets(id) {
    return Rest().get("ticketko/report/inspections/ticket/" + id);
  },
  getDeviceUtillization(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.month !== null &&
      params.month !== undefined &&
      params.month !== ""
    ) {
      data += `&month=${params.month}`;
    }
    return Rest().get(
      "ticketko/report/device-utilization?" + data.substring(1)
    );
  },
  getDeviceDailySales(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date !== null &&
      params.date !== undefined &&
      params.date !== ""
    ) {
      data += `&date=${params.date}`;
    }
    return Rest().get(
      "ticketko/report/device-daily-sales?" + data.substring(1)
    );
  },
  getTellerDailySales(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date !== null &&
      params.date !== undefined &&
      params.date !== ""
    ) {
      data += `&date=${params.date}`;
    }
    return Rest().get(
      "ticketko/report/teller-daily-sales?" + data.substring(1)
    );
  },
  getDeviceMonthlySales(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.payment_type_id !== null &&
      params.payment_type_id !== undefined &&
      params.payment_type_id !== ""
    ) {
      data += `&payment_type_id=${params.payment_type_id}`;
    }
    // if (
    //   params.date_from !== null &&
    //   params.date_from !== undefined &&
    //   params.date_from !== ""
    // ) {
    //   data += `&date_from=${params.date_from}`;
    // }
    if (
      params.month !== null &&
      params.month !== undefined &&
      params.month !== ""
    ) {
      data += `&month=${params.month}`;
    }
    return Rest().get(
      "ticketko/report/device-monthly-sales?" + data.substring(1)
    );
  },
  getRemittanceException(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/remmitance-exception?" + data.substring(1));
  },
  getDispatchMonitoring(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/report/dispatch-monitoring?" + data.substring(1)
    );
  },
  getTripSalesReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.vehicle_id !== null &&
      params.vehicle_id !== undefined &&
      params.vehicle_id !== ""
    ) {
      data += `&vehicle_id=${params.vehicle_id}`;
    }
    if (
      params.route_id !== null &&
      params.route_id !== undefined &&
      params.route_id !== ""
    ) {
      data += `&route_id=${params.route_id}`;
    }
    if (
      params.bound_id !== null &&
      params.bound_id !== undefined &&
      params.bound_id !== ""
    ) {
      data += `&bound_id=${params.bound_id}`;
    }
    return Rest().get("ticketko/report/trip-sales?" + data.substring(1));
  },
  getPassengerByVehicle(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.vehicle_id !== null &&
      params.vehicle_id !== undefined &&
      params.vehicle_id !== ""
    ) {
      data += `&vehicle_id=${params.vehicle_id}`;
    }
    if (
      params.route_id !== null &&
      params.route_id !== undefined &&
      params.route_id !== ""
    ) {
      data += `&route_id=${params.route_id}`;
    }
    if (
      params.bound_id !== null &&
      params.bound_id !== undefined &&
      params.bound_id !== ""
    ) {
      data += `&bound_id=${params.bound_id}`;
    }
    return Rest().get(
      "ticketko/report/passenger-stats-by-vehicle?" + data.substring(1)
    );
  },
  getPassengerByTime(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.vehicle_id !== null &&
      params.vehicle_id !== undefined &&
      params.vehicle_id !== ""
    ) {
      data += `&vehicle_id=${params.vehicle_id}`;
    }
    if (
      params.route_id !== null &&
      params.route_id !== undefined &&
      params.route_id !== ""
    ) {
      data += `&route_id=${params.route_id}`;
    }
    if (
      params.bound_id !== null &&
      params.bound_id !== undefined &&
      params.bound_id !== ""
    ) {
      data += `&bound_id=${params.bound_id}`;
    }
    return Rest().get(
      "ticketko/report/passenger-stats-by-time?" + data.substring(1)
    );
  },
  getPassengerByZone(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.vehicle_id !== null &&
      params.vehicle_id !== undefined &&
      params.vehicle_id !== ""
    ) {
      data += `&vehicle_id=${params.vehicle_id}`;
    }
    if (
      params.route_id !== null &&
      params.route_id !== undefined &&
      params.route_id !== ""
    ) {
      data += `&route_id=${params.route_id}`;
    }
    if (
      params.bound_id !== null &&
      params.bound_id !== undefined &&
      params.bound_id !== ""
    ) {
      data += `&bound_id=${params.bound_id}`;
    }
    return Rest().get(
      "ticketko/report/passenger-stats-by-zone?" + data.substring(1)
    ); //please change/check endpoint
  },
  getSalesReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.vehicle_id !== null &&
      params.vehicle_id !== undefined &&
      params.vehicle_id !== ""
    ) {
      data += `&vehicle_id=${params.vehicle_id}`;
    }
    if (
      params.route_id !== null &&
      params.route_id !== undefined &&
      params.route_id !== ""
    ) {
      data += `&route_id=${params.route_id}`;
    }
    if (
      params.bound_id !== null &&
      params.bound_id !== undefined &&
      params.bound_id !== ""
    ) {
      data += `&bound_id=${params.bound_id}`;
    }
    return Rest().get("ticketko/report/sales?" + data.substring(1));
  },
  getDeviceSalesReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.vehicle_id !== null &&
      params.vehicle_id !== undefined &&
      params.vehicle_id !== ""
    ) {
      data += `&vehicle_id=${params.vehicle_id}`;
    }
    if (
      params.route_id !== null &&
      params.route_id !== undefined &&
      params.route_id !== ""
    ) {
      data += `&route_id=${params.route_id}`;
    }
    if (
      params.bound_id !== null &&
      params.bound_id !== undefined &&
      params.bound_id !== ""
    ) {
      data += `&bound_id=${params.bound_id}`;
    }
    return Rest().get("ticketko/report/device-sales?" + data.substring(1));
  },
  getTripOperation(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/report/trip-operation?" + data.substring(1));
  },
  getTORMain(id) {
    return Rest().get("ticketko/report/trip-operation/main/" + id);
  },
  getTORRemittance(id) {
    return Rest().get("ticketko/report/trip-operation/remittance/" + id);
  },
  getTORTrip(id) {
    return Rest().get("ticketko/report/trip-operation/trip/" + id);
  },
  getTORTicket(id) {
    return Rest().get("ticketko/report/trip-operation/ticket/" + id);
  },
  getTORInspection(id) {
    return Rest().get("ticketko/report/trip-operation/inspection/" + id);
  },
  getTORFuel(id) {
    return Rest().get("ticketko/report/trip-operation/fuel/" + id);
  },
  getTORViolation(id) {
    return Rest().get("ticketko/report/trip-operation/violation/" + id);
  },
  getTORTrouble(id) {
    return Rest().get("ticketko/report/trip-operation/trouble/" + id);
  },
  getInternalAudit(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.route !== null &&
      params.route !== undefined &&
      params.route !== ""
    ) {
      data += `&route=${params.route}`;
    }
    return Rest().get("ticketko/report/internal-audit?" + data.substring(1));
  },
  getDailyCollectionTransmittalReport(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date=${params.date_from}`;
    }
    return Rest().get(
      "ticketko/report/daily-collection-transmittal?" + data.substring(1)
    );
  },
  getViolationReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/report/violation?" + data.substring(1));
  },
  getTroubleReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/report/trouble?" + data.substring(1));
  },
  getComputedBaggageTrans(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/report/sub-com-baggage?" + data.substring(1));
  },
  // Subcompany Esales Report
  getSubCompanyEsales(params) {
    var data = ``;
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub-company-esales?" + data.substring(1));
  },
  getComputedBaggageFinancialTrans(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get(
      "ticketko/report/sub-com-baggage-financial?" + data.substring(1)
    );
  },
  getRemittanceIds(params) {
    var data = ``;
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/report/remittance-ids?" + data.substring(1));
  },
  getExpensesTypes(params) {
    var data = ``;
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/report/expense-types?" + data.substring(1));
  },
  getRemittanceSummary(body) {
    return Rest().post("ticketko/report/remittance-summary", body);
  },
  getTicketSummary(body) {
    return Rest().post("ticketko/report/ticket-summary", body);
  },
  getExpensesSummary(body) {
    return Rest().post("ticketko/report/expense-summary", body);
  }, // Terminal Remittance
  getTerminalExpensesTypes(params) {
    var data = ``;
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get(
      "ticketko/report/terminal-expense-types?" + data.substring(1)
    );
  },
  getTerminalRemittanceIds(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get(
      "ticketko/report/terminal-remittance-ids?" + data.substring(1)
    );
  },
  getTerminalRemittanceSummary(body) {
    return Rest().post("ticketko/report/terminal-remittance-summary", body);
  },
  getTerminalTicketSummary(body) {
    return Rest().post("ticketko/report/terminal-ticket-summary", body);
  },
  getTerminalExpensesSummary(body) {
    return Rest().post("ticketko/report/terminal-expense-summary", body);
  },
  getTellerStatus(params) {
    var data = ``;
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/common/setting-status?" + data.substring(1));
  },
  getTellerEndOfDay(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }    
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.teller_status !== null &&
      params.teller_status !== undefined &&
      params.teller_status !== ""
    ) {
      data += `&teller_status=${params.teller_status}`;
    }
    return Rest().get("ticketko/report/teller-end-of-day?" + data.substring(1));
  },
  getTellerEndOfDayTripSummaryHeader(params) {
    var data = ``;
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    return Rest().get("ticketko/report/teller-end-of-day/trip-summary-header?" + data.substring(1));
  },
  getTellerEndOfDayTripSummaryTicketIssuance(params) {
    var data = ``;
    if (
      params.remittance_sync_id !== null &&
      params.remittance_sync_id !== undefined &&
      params.remittance_sync_id !== ""
    ) {
      data += `&remittance_sync_id=${params.remittance_sync_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/report/teller-end-of-day/trip-summary-ticket-issuance?" + data.substring(1));
  },
    getEndOfDay(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/report/end-of-day?" + data.substring(1));
  },
  getTellerEndOfDayTickets(params) {
    var data = ``;
    if (
      params.dispatch_sync_id !== null &&
      params.dispatch_sync_id !== undefined &&
      params.dispatch_sync_id !== ""
    ) {
      data += `&dispatch_sync_id=${params.dispatch_sync_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/report/teller-end-of-day/ticket?" + data.substring(1));
  },
  getSubCompanySettingsStatuses(params) {
    var data = ``;
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/common/setting-status?" + data.substring(1));
  },
  getBaggageSummary(body) {
    return Rest().post("ticketko/report/baggage-summary", body);
  },
  getTellerRemittanceIds(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date !== null &&
      params.date !== undefined &&
      params.date !== ""
    ) {
      data += `&date=${params.date}`;
    }
    return Rest().get(
      "ticketko/report/teller-remittance-ids?" + data.substring(1)
    );
  },
  getTellerRemittanceSummary(body) {
    return Rest().post("ticketko/report/teller-remittance-summary", body);
  },
  getTellerTicketSummary(body) {
    return Rest().post("ticketko/report/teller-ticket-summary", body);
  },
  isTellerApp(params) {
    var data = ``;
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }

    return Rest().get("ticketko/report/is-teller-app?" + data.substring(1));
  },
  getRoutesFilter(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/sub/route-filter?" + data.substring(1));
  },
};
